



























import { FilterIdEnum } from '../../enums';

import { UiButton, UiMenu } from '../keen-ui';
import CustomDateSelector from './custom-date-selector.component.vue';

export enum OptionsEnum {
  TODAY = 'today',
  WEEK = 'week',
  MONTH = 'month',
  CUSTOM = 'custom'
}

export default {
  name: 'date-filter-selector',
  components: {
    CustomDateSelector,
    UiButton,
    UiMenu
  },
  computed: {
    selectedValuesText: function (): string {
      let fromDate: Date, toDate: Date;
      if (!!this.filter.selectedValues[0]) {
        fromDate = new Date(this.filter.selectedValues[0]);
        fromDate.setUTCHours(12);
      }
      if (!!this.filter.selectedValues[1]) {
        toDate = new Date(this.filter.selectedValues[1]);
        toDate.setUTCHours(12);
        toDate.setUTCDate(toDate.getUTCDate() - 1);
      }
      const toLocaleStringOptions = { year: '2-digit', month: 'short', day: '2-digit' } as const;
      if (!!fromDate && !!toDate) {
        if (fromDate.getTime() === toDate.getTime()) {
          return fromDate.toLocaleString(this.$epb.locale, toLocaleStringOptions);
        }
        return [
          fromDate.toLocaleString(this.$epb.locale, toLocaleStringOptions),
          toDate.toLocaleString(this.$epb.locale, toLocaleStringOptions)
        ].join(' - ');
      }
      const messages = this.$epb.messages.filters.values[FilterIdEnum.DATE];
      if (!!fromDate) {
        return this.$epb.utils.compileMessage(messages.from, {
          date: fromDate.toLocaleString(this.$epb.locale, toLocaleStringOptions)
        });
      }
      if (!!toDate) {
        return this.$epb.utils.compileMessage(messages.to, {
          date: toDate.toLocaleString(this.$epb.locale, toLocaleStringOptions)
        });
      }
      return '';
    }
  },
  props: {
    filter: Object
  },
  data() {
    const messages = this.$epb.messages.filters.values[FilterIdEnum.DATE];
    return {
      messages: messages,
      dateFilterMenuOptions: [
        {
          id: OptionsEnum.TODAY,
          label: messages.today.label
        },
        {
          id: OptionsEnum.WEEK,
          label: messages.week.label,
          secondaryText: messages.week.secondaryText
        },
        {
          id: OptionsEnum.MONTH,
          label: messages.month.label,
          secondaryText: messages.month.secondaryText
        },
        {
          type: 'divider'
        },
        {
          id: OptionsEnum.CUSTOM,
          label: messages.custom.label,
          icon: 'calendar'
        }
      ],
      selectedOption: undefined,
      FilterIdEnum
    };
  },
  methods: {
    onOptionSelected: function (option: any) {
      const now = new Date(Date.now());
      const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      const startDate = new Date(today.getTime());
      const endDate = new Date(today.getTime());
      const selectedValues = {
        [OptionsEnum.TODAY]: () => [startDate.getTime(), endDate.getTime()],
        [OptionsEnum.WEEK]: () => {
          startDate.setUTCDate(startDate.getUTCDate() - 7);
          endDate.setUTCDate(endDate.getUTCDate() - 1);
          return [startDate.getTime(), endDate.getTime()];
        },
        [OptionsEnum.MONTH]: () => {
          startDate.setUTCDate(startDate.getUTCDate() - 30);
          endDate.setUTCDate(endDate.getUTCDate() - 1);
          return [startDate.getTime(), endDate.getTime()];
        },
        [OptionsEnum.CUSTOM]: () => {
          this.open();
        }
      }[option.id]();

      if (option.id !== OptionsEnum.CUSTOM) {
        const date = new Date(selectedValues[1]);
        date.setUTCDate(date.getUTCDate() + 1);
        selectedValues[1] = date.getTime();
        this.$emit('selectedValuesChange', selectedValues);
      }
    },
    open() {
      this.$refs.customDateSelector.open();
    }
  },
  watch: {
    filter: {
      handler: function () {
        let selectedOption: string;
        const startDateInMillis = this.filter.selectedValues[0];
        const endDateInMillis = this.filter.selectedValues[1];
        if (!!startDateInMillis && !!endDateInMillis) {
          const now = new Date(Date.now());
          const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
          const tomorrow = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), (now.getUTCDate() + 1)));
          if ((startDateInMillis === today.getTime()) && (endDateInMillis === tomorrow.getTime())) {
            selectedOption = this.messages.today.label;
          } else if (endDateInMillis === today.getTime()) {
            const weekStartDate = new Date(today.getTime());
            weekStartDate.setUTCDate(weekStartDate.getUTCDate() - 7);
            const monthStartDate = new Date(today.getTime());
            monthStartDate.setUTCDate(monthStartDate.getUTCDate() - 30);
            selectedOption = {
              [weekStartDate.getTime()]: this.messages.week.label,
              [monthStartDate.getTime()]: this.messages.month.label
            }[startDateInMillis];
          }
          if (!selectedOption) {
            selectedOption = this.messages.custom.label;
          }
        }
        this.selectedOption = (selectedOption || this.$epb.messages.filters.names[FilterIdEnum.DATE]);
      },
      immediate: true
    }
  }
};
